import { render, staticRenderFns } from "./PreviewFormsRELOC.vue?vue&type=template&id=b09701ea"
import script from "./PreviewFormsRELOC.vue?vue&type=script&lang=ts"
export * from "./PreviewFormsRELOC.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports